type ReplaceState = (state: unknown, title: string, url: string) => void;

// Writes app state into the address bar, at most once per `interval` ms; the
// last call in a burst always lands. Safari refuses history.replaceState
// beyond 100 calls in 10 seconds and throws, which a colour drag reaches
// within seconds. A refused write is skipped rather than allowed to break
// the app: the address only matters when the page is reloaded.
export function createUrlWriter(getReplaceState: () => ReplaceState, interval: number) {
  let last = -Infinity;
  let timer: ReturnType<typeof setTimeout> | undefined;
  let pending: { state: unknown; url: string } | undefined;

  const flush = () => {
    timer = undefined;
    if (!pending) return;
    const { state, url } = pending;
    pending = undefined;
    last = Date.now();
    try {
      getReplaceState()(state, "Atlas Studio", url);
    } catch (err) {
      // Refused (rate limit). The next write carries the latest state.
    }
  };

  return (state: unknown, url: string) => {
    pending = { state, url };
    if (timer !== undefined) return;
    const wait = last + interval - Date.now();
    if (wait <= 0) flush();
    else timer = setTimeout(flush, wait);
  };
}
